import { first, get } from 'lodash'
import { scenarioStore } from 'services/state'
import { defaultPermission } from '../state'
import { tableParser } from './table'

export const updateState = (state, newData) =>
  state.update((prevState) => ({
    ...prevState,
    ...newData
  }))

export const updateBuffer = (newBuffer) => {
  scenarioStore.update((prevState) => ({
    ...prevState,
    buffer: {
      ...prevState.buffer,
      ...newBuffer
    }
  }))
}

export const addRows = (newRows = []) => {
  scenarioStore.update((prevState) => {
    const { originalData } = prevState

    const filteredData = originalData.filter(
      ({ id }) => id !== first(newRows)?.id
    )

    const newData = [...filteredData, ...newRows]

    return {
      ...prevState,
      originalData: newData
    }
  })
}

export const deleteRows = (onDelete) => {
  scenarioStore.update((prevState) => {
    return {
      ...prevState,
      originalData: prevState.originalData.filter(onDelete)
    }
  })
}

export const updateStatusRow = (id, newStatus) => {
  scenarioStore.update((prevState) => {
    const { originalData } = prevState
    const rowIndex = originalData.findIndex((row) => row.id === id)

    originalData[rowIndex].status = newStatus

    return {
      ...prevState,
      originalData
    }
  })
}

export const updateInstanceRow = (id, newScenarioInstance, gridApi) => {
  scenarioStore.update((prevState) => {
    const { originalData } = prevState
    const rowIndex = originalData.findIndex((row) => row.id === id)

    originalData[rowIndex].scenarioInstance = newScenarioInstance

    const formattedData = tableParser({ rowData: [originalData[rowIndex]] })
    gridApi.updateData(first(formattedData))

    return {
      ...prevState,
      originalData
    }
  })
}

export const modelPermissionsSelector = ({ scenarioModelConfig }) =>
  get(scenarioModelConfig, 'scenario.permissions', defaultPermission)
